import { autoserializeAs, autoserializeAsArray, autoserializeAsJson, autoserializeAsObjectMap } from 'dcerialize';

import { RestItemList } from './rest-item';

export enum CustomerModuleKey {
  /* eslint-disable @typescript-eslint/naming-convention */
  WEBINARS = 'WEBINARS',
  SALESIQ = 'SALESIQ',
  ONLYFREECOURSESWEB = 'ONLY_FREE_COURSES_WEB',
  ONLYFREECOURSESAPP = 'ONLY_FREE_COURSES_APP',
  MYLXPACADEMIES = 'MYLXP_ACADEMIES',
  MYLXPFACULTIES = 'MYLXP_FACULTIES',
  ENABLEDSSO = 'ENABLED_SSO',
  FACEBOOKSSO = 'FACEBOOK_SSO',
  GOOGLESSO = 'GOOGLE_SSO',
  APPLESSO = 'APPLE_SSO',
  LINKEDINSSO = 'LINKEDIN_SSO',
  TUTORLXP = 'TUTOR_LXP',
  TUTORAI = 'TUTOR_AI',
  PAYMENT_MANAGEMENT = 'PAYMENT_MANAGEMENT',
  UDAVINCI = 'UDAVINCI',
  EXTERNAL_FAQS = 'EXTERNAL_FAQS',
  HELPCENTER_BY_ZOHO = 'HELPCENTER_BY_ZOHO',
  WELCOME_VIDEO = 'WELCOME_VIDEO'
  /* eslint-enable @typescript-eslint/naming-convention */
}

export type CustomerModulesDict = Record<CustomerModuleKey, CustomerModule>;

export class CustomerModule {
  /**
   * Enabled modules
   */
  @autoserializeAs(() => Boolean) enabled?: boolean;

  /**
   * Module config dict
   */
  @autoserializeAsJson() config?: { [key: string]: any};

  constructor(enabled?: boolean, config?: { [key: string]: any}) {
    this.enabled = enabled;
    this.config = config;
  }
}

export class CustomerModules {
  /**
   * Customer modules
   */
  @autoserializeAsObjectMap(() => CustomerModule) modules: Partial<CustomerModulesDict>;

  constructor(modules?: Partial<CustomerModulesDict>) {
    this.modules = modules || { };
  }
}

export class Customer extends CustomerModules {
  @autoserializeAs(() => String) domain: string;

  @autoserializeAs(() => String) name: string;

  @autoserializeAs(() => String) logoUrlBase: string;

  constructor(domain: string, name: string, logoUrlBase: string, modules?: Partial<CustomerModulesDict>) {
    super(modules);
    this.domain = domain;
    this.name = name;
    this.logoUrlBase = logoUrlBase;
  }
}

export class CustomerList extends RestItemList<Customer> {
  /**
   * Customer list
   */
  @autoserializeAsArray(() => Customer) items: Customer[];

  /**
   * Number of customers
   */
  @autoserializeAs(() => Number) total: number;

  constructor(items: Customer[] = [], total = 0) {
    super();
    this.items = items;
    this.total = total;
  }
}
